var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"id":_vm.elementId}},[_vm._v(_vm._s(_vm.textComputed))])}
var staticRenderFns = []

export { render, staticRenderFns }